import { Component, computed, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import { BrnTabsListDirective } from '@spartan-ng/ui-tabs-brain';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';

export const listVariants = cva('items-center justify-center rounded-md', {
  variants: {
    orientation: {
      horizontal: 'h-fit',
      vertical: 'mt-2 flex-col h-fit space-y-1',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});
type ListVariants = VariantProps<typeof listVariants>;

@Component({
  selector: 'hlm-tabs-list',
  standalone: true,
  hostDirectives: [BrnTabsListDirective],
  template: '<ng-content/>',
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmTabsListComponent {
  public readonly orientation = input<ListVariants['orientation']>('horizontal');

  public readonly userClass = input<ClassValue>('');
  protected _computedClass = computed(() =>
    hlm(listVariants({ orientation: this.orientation() }), this.userClass()),
  );
}
